import { pluralRu } from '@/shared/lib'
import { Chip } from '@/shared/ui/chip'
import { Icon } from '@/shared/ui/icon'
import { type Client, fmtPhone } from '../model/schema'

interface ClientRowProps {
  client: Client
  onOpen: (client: Client) => void
}

export function ClientRow({ client, onOpen }: ClientRowProps) {
  return (
    <li>
      <button
        type="button"
        onClick={() => onOpen(client)}
        className="group flex w-full items-center gap-3 rounded-control px-3 py-2.5 text-left hover:bg-bg-elevated"
      >
        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
          {/* Метки держатся за имя, а не за правую кромку: оторванный чип
              перестаёт читаться как свойство именно этого клиента. */}
          <span className="flex min-w-0 flex-wrap items-center gap-2">
            <span className="truncate text-sm text-text-primary">{client.name}</span>
            {client.duplicateSuspects.length > 0 && (
              <Chip tone="warning" variant="soft">
                похож на дубль
              </Chip>
            )}
            {client.forgotten && <Chip variant="soft">стёрт</Chip>}
          </span>
          <span className="mono-num flex items-center gap-1 text-xs text-text-tertiary">
            <Icon name="phone" size={12} />
            {fmtPhone(client.phone)}
          </span>
        </span>
        {/* Сколько раз ходил — то, ради чего в список и заходят: постоянного
            клиента видно, не открывая карточку. */}
        {client.visits.length > 0 && (
          <span className="hidden shrink-0 text-xs text-text-tertiary sm:block">
            <span className="mono-num">{client.visits.length}</span>{' '}
            {pluralRu(client.visits.length, 'выход', 'выхода', 'выходов')}
          </span>
        )}
        {/* Строка открывает карточку — стрелка делает это видимым до клика. */}
        <Icon
          name="chevron-right"
          size={16}
          className="shrink-0 text-text-tertiary transition-colors group-hover:text-text-secondary"
        />
      </button>
    </li>
  )
}
